import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { DataProvider } from './data/DataContext';
import { AuthProvider } from './auth/AuthContext';
import '@fontsource-variable/geist';
import '@fontsource-variable/geist-mono';
import './styles/app.css';

if ('serviceWorker' in navigator && import.meta.env.PROD) navigator.serviceWorker.register('/sw.js').catch(() => undefined);
createRoot(document.getElementById('root')!).render(<StrictMode><BrowserRouter><AuthProvider><DataProvider><App /></DataProvider></AuthProvider></BrowserRouter></StrictMode>);
